import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { LibraryProvider } from './components/LibraryContext';
import { Layout } from './components/Layout';
import { LANGUAGES } from './lib/library';
import Home from './pages/Home';
import Explore from './pages/Explore';
import Article from './pages/Article';
import Learn from './pages/Learn';
import Information from './pages/Information';
import Editor from './pages/Editor';
import { PublicSources,PublicationStandards } from './pages/CorpusPublic';
import './App.css';
import './editor.css';
import './refinements.css';
import './corpus.css';
import './journal.css';
import './brand.css';

function PageMetadata() {
 const location = useLocation();
 useEffect(()=>{
  document.title = 'Mahakali Tribunal — Intelligence. Justice. Wealth.';
  let canonical=document.querySelector('link[rel="canonical"]');
  if(!canonical){canonical=document.createElement('link');canonical.rel='canonical';document.head.appendChild(canonical);}
  canonical.href=process.env.REACT_APP_BACKEND_URL+location.pathname;
  let robots=document.querySelector('meta[name="robots"]');
  if(!robots){robots=document.createElement('meta');robots.name='robots';document.head.appendChild(robots);}
  robots.content=location.pathname.startsWith('/editor')?'noindex, nofollow':'index, follow';
 },[location.pathname]);
 return null;
}
function RootHome(){const code=localStorage.getItem('mt-language');return code&&code!=='en'&&LANGUAGES.some(l=>l[0]===code)?<Navigate to={'/'+code} replace/>:<Home/>;}
function App() {
 return <BrowserRouter><LibraryProvider><PageMetadata/><Routes>
  <Route path="/editor/*" element={<Editor/>}/>
  <Route element={<Layout/>}><Route path="/" element={<RootHome/>}/></Route>
  {LANGUAGES.map(([code])=><Route path={'/'+code} element={<Layout/>} key={code}>
   <Route index element={<Home/>}/>
   <Route path="explore" element={<Explore/>}/>
   <Route path="articles/:slug" element={<Article/>}/>
   <Route path="learn" element={<Learn/>}/>
   <Route path="learn/:pathway" element={<Learn/>}/>
   <Route path="sources" element={<PublicSources/>}/>
   <Route path="standards" element={<PublicationStandards/>}/>
   <Route path=":section" element={<Information/>}/>
  </Route>)}
  <Route path="*" element={<Navigate to="/" replace/>}/>
 </Routes><Toaster position="bottom-right" richColors/></LibraryProvider></BrowserRouter>;
}
export default App;